/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { SimpleUserRequest } from '../models/SimpleUserRequest';
import { HttpFile } from '../http/http';

export class PatchedHorsePhotoRequest {
    'horse'?: string;
    'name'?: string;
    'image'?: HttpFile;
    'isHidden'?: boolean;
    'inProfile'?: boolean;
    'profileOrder'?: number;
    'user'?: SimpleUserRequest;
    'isSalePhoto'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "horse",
            "baseName": "horse",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "image",
            "baseName": "image",
            "type": "HttpFile",
            "format": "binary"
        },
        {
            "name": "isHidden",
            "baseName": "isHidden",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "inProfile",
            "baseName": "inProfile",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "profileOrder",
            "baseName": "profileOrder",
            "type": "number",
            "format": ""
        },
        {
            "name": "user",
            "baseName": "user",
            "type": "SimpleUserRequest",
            "format": ""
        },
        {
            "name": "isSalePhoto",
            "baseName": "isSalePhoto",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return PatchedHorsePhotoRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

